var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
    fill: "#045694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 12C9.25 10.4812 10.4812 9.25 12 9.25C13.5188 9.25 14.75 10.4812 14.75 12C14.75 13.5188 13.5188 14.75 12 14.75C10.4812 14.75 9.25 13.5188 9.25 12ZM12 10.35C11.0887 10.35 10.35 11.0887 10.35 12C10.35 12.9113 11.0887 13.65 12 13.65C12.9113 13.65 13.65 12.9113 13.65 12C13.65 11.0887 12.9113 10.35 12 10.35Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.575 8.975C15.575 9.27876 15.3288 9.525 15.025 9.525C14.7212 9.525 14.475 9.27876 14.475 8.975C14.475 8.67124 14.7212 8.425 15.025 8.425C15.3288 8.425 15.575 8.67124 15.575 8.975Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 9.25C6.5 7.73122 7.73122 6.5 9.25 6.5H14.75C16.2688 6.5 17.5 7.73122 17.5 9.25V14.75C17.5 16.2688 16.2688 17.5 14.75 17.5H9.25C7.73122 17.5 6.5 16.2688 6.5 14.75V9.25ZM9.25 7.6C8.33873 7.6 7.6 8.33873 7.6 9.25V14.75C7.6 15.6613 8.33873 16.4 9.25 16.4H14.75C15.6613 16.4 16.4 15.6613 16.4 14.75V9.25C16.4 8.33873 15.6613 7.6 14.75 7.6H9.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhInstagram);
export default __webpack_public_path__ + "static/media/fmh-instagram.0542510782fb2f5d4b2acb81d2d7e602.svg";
export { ForwardRef as ReactComponent };